import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import BigNumber from 'bignumber.js'

Vue.use(Vuex)

const TICKER = {
  ID: 2688,
  URL: 'https://api.coinmarketcap.com/v2/ticker/'
}

const store = new Vuex.Store({
  state: {
    address: 'VUmino3VbniKFyCzgYwpt8ZWfWumLGzSX4',
    amount: '',
    amountType: 'JPY',
    camera: false,
    characterName: null,
    characterIcon: null,
    error: false,
    errorDialog: false,
    errorDialogMessage: '',
    errorMessage: '',
    fiat: '',
    fiatRate: '',
    focused: '',
    help: false,
    loading: true,
    message: '',
    nukumolink: 'https://r.vipstarco.in/#',
    qrcode: '',
    uri: '',
    useFiat: false
  },
  mutations: {
    changeCharacter (state, character) {
      state.characterName = character.namePath
      state.characterIcon = character.icon
    },
    error (state, flg) {
      state.error = flg
    },
    errorMessage (state, message) {
      state.errorMessage = message
    },
    setAddress (state, address) {
      state.address = address
    },
    setAmount (state, amount) {
      state.amount = amount
    },
    setAmountType (state, amountType) {
      state.amountType = amountType
    },
    setCamera (state, flg) {
      state.camera = flg
    },
    setErrorDialog (state, message) {
      state.errorDialogMessage = message
      state.errorDialog = !!message
    },
    setFiat (state, amount) {
      state.fiat = amount
    },
    setFiatRate (state, amount) {
      state.fiatRate = amount
    },
    setFocused (state, value) {
      console.log(value)
      state.focused = value
    },
    setMessage (state, message) {
      state.message = message
    },
    setQRCode (state, data) {
      state.qrcode = data
    },
    setURI (state, uri) {
      state.uri = uri
      state.nukumolink = `https://r.vipstarco.in/#${uri}`
    },
    setUseFiat (state, flg) {
      state.useFiat = flg
    },
    toggleCamera (state) {
      state.camera = !state.camera
    },
    toggleHelp (state) {
      state.help = !state.help
    },
    toggleLoading (state) {
      state.loading = !state.loading
    }
  },
  actions: {
    refreshFiat ({commit, state}, amountType) {
      commit('toggleLoading')
      let currentAmountType = state.amountType
      if (amountType !== undefined) {
        currentAmountType = amountType
      }
      let uri = `${TICKER.URL}${TICKER.ID}/?convert=${currentAmountType}`
      return axios.get(uri).then(resp => {
        let quote = resp.data.data.quotes[currentAmountType]
        if (quote === null) {
          return Promise.reject(new Error(`${currentAmountType} does'nt supported`))
        } else {
          let price = new BigNumber(quote.price)
          commit('setFiatRate', price.toString())
          if (state.amountType !== currentAmountType) {
            commit('setAmountType', currentAmountType)
          }
          console.log(price.toString())
          commit('toggleLoading')
          return Promise.resolve(price.toString())
        }
      }).catch(error => {
        console.error(error)
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js